export const auth0Domain = import.meta.env.VITE_APP_AUTH0_CLIENT_DOMAIN;
export const auth0ClientId = import.meta.env.VITE_APP_AUTH0_CLIENT_ID;
export const auth0Audience = import.meta.env.VITE_APP_AUTH0_AUDIENCE;
export const csiAccountsApiBaseUrl = import.meta.env.VITE_APP_CSI_ACCOUNTS_API_BASE_URL;
export const addInVersion = import.meta.env.VITE_APP_OUTLOOK_VERSION;
export const graphApiBaseUrl = import.meta.env.VITE_APP_GRAPH_API_BASE_URL;
export const azureClientId = import.meta.env.VITE_APP_AZURE_APP_CLIENT_ID;

export const locizeProjectId = import.meta.env.VITE_APP_LOCIZE_PROJECT_ID;
export const locizeApiKey = import.meta.env.VITE_APP_LOCIZE_API_KEY;

export const csiVendorKey = import.meta.env.VITE_APP_CSI_VENDOR_KEY;
export const csiVendorAppKey = import.meta.env.VITE_APP_CSI_VENDOR_APP_KEY;
export const releaseNotesApiBaseUrl = import.meta.env.VITE_APP_RELEASE_NOTES_API_BASE_URL;
